import React, { useMemo, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { login, logout } from '../../services/auth.service';
import './AppHeader.scss';
import { Logo } from '../logo/icon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';
import { useDesktopMode } from '../../services/hooks/useDesktopMode';
import Container from '@mui/material/Container/Container';
import Stack from '@mui/material/Stack/Stack';
import Button from '@mui/material/Button/Button';
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';

export default function DefaultAppHeader() {
    const desktopMode = useDesktopMode();

    const { user, loading } = useAuth();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    return (
        <Box className="app-header no-print-no-display" id="back-to-top-anchor" sx={{
            color: 'text.primary',
            backgroundColor: 'background.default'
        }} >
            <Container >
                <Stack direction="row" alignItems="center" spacing={2} className="header-container">

                    <Link to={'/'} className='main-link'>
                        <Logo size="small" />
                        {desktopMode && <Typography component="h1" variant="h6" color="text.primary">Wayfinder</Typography>}
                    </Link>

                    <div className="spacer"></div>

                    {
                        loading && <CircularProgress />
                    }
                    {
                        !loading && !user && <Button onClick={(e) => { login(); }}>Login/Register</Button>
                    }
                    {
                        (!loading && !!user) && <>
                            {desktopMode ? (
                                <Button id="basic-button"
                                    aria-controls={open ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={handleClick}>{user.username}</Button>
                            ) : (
                                <IconButton
                                    id="basic-button"
                                    aria-controls={open ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={handleClick}
                                    size="small"
                                >
                                    <Avatar sx={{ width: 28, height: 28, fontSize: 13 }}>
                                        {user.username?.charAt(0).toUpperCase()}
                                    </Avatar>
                                </IconButton>
                            )}
                            <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button'
                                }}
                            >
                                <MenuItem onClick={logout}>Logout</MenuItem>
                            </Menu>
                        </>
                    }
                </Stack>
            </Container>

        </Box>
    );
}
